<template>
  <v-card
    tile
    elevation="0"
    :color="
      status === 'in_process'
        ? 'orange'
        : isWaitingApproval
        ? 'orange'
        : '#14b86d'
    "
    :class="
      $vuetify.breakpoint.mdAndUp ? 'pa-4 px-6 mt-4 rounded-lg' : 'pa-4 px-6'
    "
  >
    <v-row align="center" no-gutters>
      <v-col :cols="status === 'in_process' ? '12' : '8'">
        <v-row no-gutters>
          <span class="white--text checkout-h2" style="font-weight: bold">
            {{
              status === "in_process"
                ? $t("finished.orderAnalysis")
                : isWaitingApproval
                ? "Pedido aguardando aprovação"
                : $t("finished.orderPlaced")
            }}
          </span>
        </v-row>
        <v-row class="mt-2" no-gutters>
          <span v-if="!isWaitingApproval" class="checkout-h4 white--text">
            {{
              status === "in_process"
                ? $t("finished.detailsOrderAnalysis")
                : $t("finished.detailsOrder")
            }}
            {{
              buyer && status !== "in_process" && !isWaitingApproval
                ? buyer.customer_email
                : ""
            }}
          </span>
          <span
            v-else
            class="conclusion-message"
            v-html="eventDetails.mensagem_aguardando_aprovacao_pedido"
          ></span>
        </v-row>
      </v-col>
      <v-spacer></v-spacer>
      <v-icon
        v-if="status !== 'in_process' && !isWaitingApproval"
        size="66"
        color="white"
      >
        mdi-check-circle-outline
      </v-icon>
    </v-row>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["buyer", "finalDetails", "eventDetails"]),

    status() {
      if (this.finalDetails) {
        return this.finalDetails.status;
      }
      return "paid";
    },

    isWaitingApproval() {
      return (
        this.finalDetails?.orderStatus === "W" ||
        this.finalDetails?.orderData?.status === "W"
      );
    },
  },
};
</script>

<style>
.conclusion-message p,
.conclusion-message p strong {
  color: white !important;
  margin: 0px !important;
}
</style>
